import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const ProvinciaSelect = ({ disabled, idDepartamento, ...props }) => {
  const fetcher = React.useMemo(() => {
    return () =>
      TablaComunService.getAsSelect(TiposTablaComunConstant.PROVINCIA, {
        _idDepartamento: idDepartamento
      }).then(({ data }) => data)
  }, [idDepartamento])

  const { data: provincias, isValidating } = useSwr(`select_provincia_${idDepartamento}`, fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  return (
    <Form.Select {...props} disabled={disabled || isValidating}>
      <option value=''>Seleccionar</option>
      {provincias.map((val, key) => (
        <option key={key} value={val._id}>
          {val.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(ProvinciaSelect)
